import { TableColumnsType } from "antd";
import { UserRateDomain } from "../../models/commonModels";
import award from './../../image/1000.png'
import styles from './RaitingPage.module.css'

export const columns: TableColumnsType<UserRateDomain> = [
  {
    title: 'Место',
    dataIndex: 'user_id',
    width:65,
    render:(item, record, index)=>(<>{index+1}</>)
  },
  {
    title: 'Имя Фамилия',
    dataIndex: 'user_name',
       render(text,record){
        return {
            props:{

            },
            children:<div className={styles.raiting_page_item}>{text}</div>
        }
    }
  },
  {
    title: 'Результат',
    dataIndex: 'distance_length',
    width:85,
    render(text,record){
        return {
            props:{
                
            },
            children:<div style={{textAlign:"center", fontSize:"14px", fontWeight:"700", padding:"0"}}>{text.toLocaleString('ru-RU')}</div>
        }
    }
  },
  {
    title: '',
    dataIndex: 'awards',
    width:27,
    render(text,record){
        return {
            props:{

            },
            children:
            <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
              {text!=""&&<img style={{maxWidth:"25px", height:"auto"}} src={"https://sportsrestaurant.online"+text}/>}
            </div>
        }
    }
  }
];